var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"spinner",style:({ width: `${_vm.width}px`, height: `${_vm.height}px`, borderWidth: `${_vm.border}px` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }